export default __webpack_public_path__ + "static/media/R_icon.716c333f.svg";